/**
 * Service for product API calls
 */
import User from "@/models/User";
import { apiClient } from "./Api";

// @ts-ignore
import { mapKeys } from "lodash"; //For whatever unknown wild reason when I compile I am getting mapKeys is not available from lodash - it is and still does the job it is suppose.
//error like this are absolutely ridiculous and waste hours of time wth?

export async function register(payLoad: object) {
  await apiClient.get("sanctum/csrf-cookie");
  const { statusText: response } = await apiClient.post("/register", payLoad);
  return response;
}

export async function registerSelf(payLoad: object) {
  await apiClient.get("sanctum/csrf-cookie");
  const { statusText: response } = await apiClient.post("/register-self", payLoad);
  return response;
}

export async function sendVerificationCode(email: string) {
  const { data } = await apiClient.post("/email/send-code", { email });
  return data;
}

export async function verifyEmailCode(email: string, code: string) {
  const { data } = await apiClient.post("/email/verify-code", { email, code });
  return data;
}

//TODO update name to resetPassword
export async function update(payLoad: object) {
  //TODO We want local to camelCase, however some API/backend logic
  //TODO requires snake, such as password_confirmation, quickfix
  //TODO is to transform the object as below. Long term fix is
  //TODO address this through axios request interceptor and ensure
  //TODO the backend is set up correctly via middleware
  // eslint-disable @typescript-eslint/camelcase
  const transformedPayload = mapKeys(payLoad, (_value: any, key: string) => {
    if (key === "passwordConfirmation") return "password_confirmation";
    return key;
  });
  const { statusText: response } = await apiClient.post<string>("/email/reset", transformedPayload);
  await apiClient.get("sanctum/csrf-cookie");
  return response;
}

export async function login(payLoad: { email: string; password: string; remember?: boolean }) {
  if (!payLoad.remember) {
    delete payLoad.remember;
  }
  await apiClient.get("sanctum/csrf-cookie");
  try {
    const { statusText: response } = await apiClient.post<string>("/login", payLoad);
    return response;
  } catch (error: any) {
    return { error: true, data: error?.response?.data };
  }
}

export async function resendVerification() {
  const { data } = await apiClient.post("/email/resend");
  return data;
}

// export async function login(payLoad: { email: string; password: string; remember?: boolean }) {
//   if (!payLoad.remember) {
//     delete payLoad.remember;
//   }
//   await apiClient.get("sanctum/csrf-cookie");
//   try {
//     const { statusText: response } = await apiClient.post<string>("/login", payLoad);
//     return response;
//   } catch (error) {
//     return "error";
//   }
// }

export async function logout() {
  const logout = apiClient.post("/logout");
  await apiClient.get("sanctum/csrf-cookie");
  return logout;
}

export async function fetchUser() {
  const { data: user } = await apiClient.get<User>("/api/user");
  return user;
}
